// src/Pages/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

// Optional logo & icons
import logo from '../images/CloudkidTextLogo-White.png';
import mailIcon from '../assets/icons/mail.svg';
import keyIcon from '../assets/icons/key.svg';

function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await api('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);
      localStorage.setItem('email', data.email);
      localStorage.setItem('name', data.name);
      localStorage.setItem('role', data.role);

      if (onLoginSuccess) {
        onLoginSuccess();
      }
      navigate('/');
    } catch (err) {
      setError('Invalid email or password.');
    }
  };

  return (
    <div style={styles.container}>
      {/* Logo (optional) */}
      {logo && <img src={logo} alt="Cloudkid Logo" style={styles.logo} />}

      <h2 style={{ marginBottom: '20px' }}>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.fieldWrapper}>
          {mailIcon && <img src={mailIcon} alt="Email Icon" style={styles.icon} />}
          <input
            type="email"
            placeholder="Email..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.fieldWrapper}>
          {keyIcon && <img src={keyIcon} alt="Password Icon" style={styles.icon} />}
          <input
            type="password"
            placeholder="Password..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
        </div>

        <button type="submit" style={styles.loginButton}>Login</button>
      </form>
    </div>
  );
}

const styles = {
  /**
   * The main login "card" container
   * centered horizontally by "margin: 50px auto"
   * => 50px top/bottom, auto left/right
   */
  container: {
    backgroundColor: '#1e1e1e',
    width: '400px',
    maxWidth: '90%',
    margin: '100px auto', // <<=== THIS centers horizontally
    padding: '40px 30px',
    borderRadius: '8px',
    color: '#fff',
    textAlign: 'center',
    transform: 'translateX(-120px)'
  },

  logo: {
    width: '180px',
    height: 'auto',
    marginBottom: '20px',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },

  fieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#2c2c2c',
    borderRadius: '6px',
    padding: '10px', // Thicker vertical padding
  },

  icon: {
    width: '20px',
    height: '20px',
    marginRight: '8px',
    filter: 'invert(60%)', // approximate #757575 if original icon is white
  },

  input: {
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    color: '#ffffff',
    fontSize: '1rem',
  },

  loginButton: {
    backgroundColor: '#555555',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '10px',
    fontSize: '1rem',
    cursor: 'pointer',
  },
};

export default LoginPage;